import templateUrl from "emun.auth/register-retailer.prompt.htm";
import open from "webmodals/open";
import modals from "webmodals/modals";
import config from "emun.auth/auth.config";

class controller {
	constructor($session, $scope, options) {
		const $ctrl = this;
		const params = Object.assign({}, options, $ctrl.options);
		$ctrl.model = params.model || {};
		$ctrl.retailer = params.retailer || $ctrl.model.retailer;
		$ctrl.language = $ctrl.model.language || "en";
		$ctrl.title = params.title;
		if ($ctrl.title == "fr") $ctrl.title = " Application Pour Ouverture De Compte";
		else $ctrl.title = " New Account Application";
		$scope.$on("$retailerRequestSubmitted", res => {
			$ctrl.$dismiss(res);
		});
	}
}

export default options =>
	open({
		size: options.size || "lg",
		backdrop: "static",
		templateUrl: options.templateUrl || templateUrl,
		controller,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			options: () => options
		}
	}).result;
